import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    popup: {
      width: '100%',
      height: '100vh',
      background: 'rgba(0, 0, 0, .3)',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: 10,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      textAlign: 'center',
      marginTop: 0,
      lineHeight: 1.4,
    },
    iconWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon: {
      width: '100px',
      height: '100px',
      background: '#fff',
      borderRadius: '50%',
      padding: '20px',
    },
    wrapper: {
      width: '600px',
      background: '#fff',
      borderRadius: 16,
    },
    content: {
      padding: '20px 65px 30px 65px',
      paddingTop: '0',
    },
    goBtn: {
      height: 64,
      fontSize: 16,
      width: 400,
      padding: 0,
      fontWeight: 600,
      margin: '32px auto 16px auto',
      display: 'block',
    },
    link: {
      textDecoration: 'underline',
      color: '#5856d6',
      fontWeight: 'bold',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }
})
